<div class="title-xs title">
  {{ title() | translate }}
  <div class="tooltip" [tooltip]="tooltip()">
    <smw-icon [icon]="tooltipIcon" />
  </div>
</div>

@if (bannerContent(); as bannerContent) {
  <smw-banner>
    <ng-container [ngTemplateOutlet]="bannerContent" />
  </smw-banner>
}

<div class="steps">
  <ng-content />
</div>
